import React from 'react';
import Reveal from '../lib/Reveal.jsx';

// Names intentionally placeholder — to be confirmed before publishing.
const FOLKS = [
  { name: '[Founder name]', role: 'Co-Founder · Managing Partner', bio: 'Banking technology, applied AI, enterprise transformation. Former senior leadership at major Israeli banks; CEO across two fintech ventures.' },
  { name: '[Founder name]', role: 'Co-Founder · CTO', bio: 'Agentic SDLC, context engineering, knowledge systems. Active research collaboration with Stanford, CMU, Columbia.' },
  { name: '[Partner name]', role: 'Partner · Financial Infrastructure', bio: 'Payments, clearing, regulatory technology. Direct experience across Bank of Israel, SHVA, MASAV programs.' },
  { name: '[Partner name]', role: 'Partner · Cross-border', bio: 'Remittance corridors, FX routing, digital wallets. Built and run cross-border products end to end.' },
];

export default function People({ tweaks }) {
  return (
    <section id="people" className="section" style={{ background: 'var(--paper-deep)' }}>
      <div className="container">
        <div className="grid12" style={{ marginBottom: 64, alignItems: 'end' }}>
          <Reveal style={{ gridColumn: 'span 6' }}>
            <div className="section-marker" style={{ marginBottom: 24 }}>
              {tweaks.sectionDividers === 'numbered' ? '06 / People' : 'People'}
            </div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: 'clamp(36px, 5vw, 60px)', lineHeight: 1.05, letterSpacing: '-0.025em', margin: 0, textWrap: 'balance' }}>
              Operators, engineers, <span style={{ fontStyle: 'italic', color: 'var(--clay)' }}>researchers.</span>
            </h2>
          </Reveal>
          <Reveal style={{ gridColumn: '8 / span 5' }}>
            <p style={{ fontSize: 16, lineHeight: 1.6, color: 'var(--ink-60)', margin: 0, maxWidth: '40ch' }}>
              A small senior team. Each engagement is led by a partner who has shipped what you're trying to ship — not by a deck and a pyramid below it.
            </p>
          </Reveal>
        </div>

        <Reveal stagger className="mobile-collapse-2" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 24 }}>
          {FOLKS.map((p, i) => (
            <div key={i} className="mobile-people-row" style={{ borderTop: '1px solid var(--ink-24)', paddingTop: 20, display: 'grid', gridTemplateColumns: '120px 1fr', gap: 24 }}>
              <div style={{
                width: 100, height: 120, borderRadius: 6,
                background: 'linear-gradient(140deg, var(--paper-ink), var(--paper-soft))',
                border: '1px solid var(--ink-12)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontFamily: 'var(--font-display)', fontStyle: 'italic',
                fontSize: 32, color: 'var(--ink-40)',
              }}>·</div>
              <div>
                <div className="mono-label" style={{ color: 'var(--clay)', marginBottom: 8 }}>{p.role}</div>
                <h4 style={{
                  fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: 24, margin: '0 0 10px',
                  letterSpacing: '-0.01em',
                  fontStyle: p.name.startsWith('[') ? 'italic' : 'normal',
                  color: p.name.startsWith('[') ? 'var(--ink-60)' : 'var(--ink)',
                }}>{p.name}</h4>
                <p style={{ fontSize: 14, color: 'var(--ink-60)', margin: 0, lineHeight: 1.55, maxWidth: '40ch' }}>{p.bio}</p>
              </div>
            </div>
          ))}
        </Reveal>

        <Reveal style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid var(--ink-12)' }}>
          <div className="mono-label" style={{ color: 'var(--ink-40)', maxWidth: '60ch' }}>
            — Names and titles shown as placeholders pending founder confirmation. See content checklist before publishing.
          </div>
        </Reveal>
      </div>
    </section>
  );
}
